import script from "./PreviewFileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewFileModal.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewFileModal.vue?vue&type=style&index=0&id=7e6a7b4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e6a7b4a"]])

export default __exports__